"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveViews = void 0;
const command_manager_1 = require("../../command_manager");
const lodash_1 = require("lodash");
const model_1 = require("../../model");
const types_1 = require("../../types");
const i18n_1 = require("../../exports/i18n");
const store_1 = require("../../exports/store");
exports.moveViews = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { data } = options;
        const datasheetId = store_1.Selectors.getActiveDatasheetId(state);
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        if (!snapshot) {
            return null;
        }
        const views = snapshot.meta.views;
        if ((0, lodash_1.isEmpty)(data)) {
            return null;
        }
        const actions = data.reduce((collected, recordOption) => {
            const { newIndex, viewId } = recordOption;
            // Check if viewId exists
            if (!(0, lodash_1.find)(views, { id: viewId })) {
                throw new Error((0, i18n_1.t)(i18n_1.Strings.error_move_view_failed_not_found_target));
            }
            const action = model_1.DatasheetActions.moveView2Action(snapshot, { viewId, target: newIndex });
            action && collected.push(action);
            return collected;
        }, []);
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
/*

declare module '../../command_manager/command_manager' {
  interface CollaCommandManager {
    execute(options: IMoveViewOptions & { cmd: 'MoveViews' });
  }
}

*/
//# sourceMappingURL=move_views.js.map